const data = {
  pageData: {
    _id: "4dTQcIGijLUuqB-j3H_me",
    title: "Homepage",
    style: {
      background: "#ffffff",
      width: "80%",
      maxWidth: "1400px",
      borderSize: "1px",
      borderType: "solid",
      borderColor: "#dddddd",
      borderRadius: "4px",
      borderSelect: "all",
    },
  },
  sectionData: [
    {
      _id: "3fl7H-5be-SkzISsDejBd",
      layout: "two_column_layout_5050",
      type: "header",
      content: [
        {
          position: "default",
          columns: ["fydpEG38vjxUbtVjSxJwe"],
        },
        {
          position: "default",
          columns: ["mydpE348vjxUbtVjSxJwe"],
        },
      ],
      style: {
        background: "none",
        width: "100%",
        paddingTop: 10,
        paddingSelect: "select",
        wrap: "nowrap",
      },
    },

    {
      _id: "vu567u57353vu35uvb3567",
      layout: "one_column_layout",
      content: [
        {
          position: "default",
          columns: ["ethn673rtb5366uk099"],
        },
      ],
      style: {
        background: "none",
        width: "100%",
        paddingTop: 10,
        paddingSelect: "select",
        wrap: "nowrap",
      },
    },

    {
      _id: "S1UtpesVpckpfvzSVqAQM",
      layout: "one_column_layout",
      content: [
        {
          position: "center",
          columns: ["7vxqu0BKnkDJJxNU8iBUm"],
        },
      ],
      style: {
        background: "none",
        width: "100%",
        paddingTop: 0,
        paddingBottom: 24,
        paddingSelect: "select",
        wrap: "wrap",
      },
    },
    {
      _id: "SWE3_lGx-fopIZgdAJwcb",
      layout: "three_column_layout_333333",
      content: [
        {
          position: "left",
          columns: ["PSiKuYCIIjyUiVM5nMLjR"],
        },
        {
          position: "center",
          columns: ["EvyPzsDPVb-3Jx3F9vqBJ"],
        },
        {
          position: "right",
          columns: ["H9k4F9kt4Kb4hg3f3f1m"],
        },
      ],
      style: {
        background: "none",
        width: "100%",
        paddingTop: 10,
        paddingBottom: 10,
        paddingSelect: "select",
        wrap: "wrap",
      },
    },
    {
      _id: "SG09k3HG9rhbk34G9k34g34g",
      layout: "one_column_layout",
      content: [
        {
          position: "center",
          columns: ["mg954G9k534G9k534rth"],
        },
      ],
      style: {
        background: "none",
        width: "100%",
        paddingTop: 10,
        paddingBottom: 10,
        paddingSelect: "select",
        wrap: "wrap",
      },
    },
    {
      _id: "kGsYEK_SVfYovo0Xikvia",
      layout: "one_column_layout",
      content: [
        {
          position: "center",
          columns: ["rdTS-deY4VY8ANjWIxL8z"],
        },
      ],
      style: {
        background: "none",
        width: "92%",
        paddingTop: 10,
        paddingBottom: 10,
        paddingSelect: "select",
        wrap: "wrap",
        align: "center",
      },
    },

    {
      _id: "lmTUfqMF7lTZYx-mcG5n3",
      layout: "two_column_layout_5050",
      content: [
        {
          position: "left",
          columns: ["uLHhlU_unzF58GxUi6nJF"],
        },
        {
          position: "right",
          columns: ["1sEvvov8Oqktyp6-CeJNt"],
        },
      ],
      style: {
        background: "#f1f1f1",
        width: "100%",
        paddingSelect: "select",
        wrap: "wrap",
        marginTop: "80px",
      },
    },
    {
      _id: "4MyHl9k54h4h4334tvVww1",
      layout: "three_column_layout_333333",
      content: [
        {
          position: "left",
          columns: ["ergt0kG54g809J54ghrt"],
        },
        {
          position: "center",
          columns: ["ggkmgK096VB89hj34g1"],
        },
        {
          position: "right",
          columns: ["gb45o9jh35IBenbuoiyt"],
        },
      ],
      style: {
        background: "none",
        width: "70%",
        paddingSelect: "select",
        wrap: "wrap",
        marginTop: "80px",
      },
    },

    {
      _id: "G034F93H4056ih4h53g34",
      layout: "one_column_layout",
      content: [
        {
          position: "center",
          columns: ["Gow8FD893uhh567hgv45"],
        },
      ],
      style: {
        background: "none",
        width: "100%",
        paddingTop: 50,
        paddingBottom: 50,
        paddingSelect: "select",
        wrap: "wrap",
      },
    },

    {
      _id: "2FFnsZwEdiTmJblgpwIne",
      layout: "two_column_layout_5050",
      content: [
        {
          position: "center",
          columns: ["mmA1e65RfIIAa3IVubb7U"],
        },
      ],
      style: {
        background: "none",
        width: "100%",
        paddingTop: 0,
        paddingBottom: 50,
        paddingSelect: "select",
        wrap: "wrap",
      },
    },
    {
      _id: "87ergijmHewF4j9g53g1",
      layout: "four_column_layout_25252525",
      content: [
        {
          position: "left",
          columns: ["abw4b5yh7924924650by9"],
        },
        {
          position: "center",
          columns: ["sfdgFG943g£90k354gefb"],
        },
        {
          position: "center",
          columns: ["Jokje0jVG£093jg345y3"],
        },
        {
          position: "right",
          columns: ["aWetgr9k4htehtrg9k54h"],
        },
      ],
      style: {
        background: "none",
        width: "100%",
        paddingTop: 0,
        paddingBottom: 50,
        paddingSelect: "select",
        wrap: "wrap",
      },
    },
    {
      _id: "VGe4rhHTE456hh35352",
      layout: "one_column_layout",
      content: [
        {
          position: "default",
          columns: ["0gEL5UTywUKrxbjf6HDHy"],
        },
      ],
      style: {
        background: "none",
        width: "100%",
        paddingTop: 0,
        paddingBottom: 0,
        paddingSelect: "select",
        wrap: "wrap",
      },
    },
    {
      _id: "LVDPPHKPhECCZ5J2FH890",
      layout: "two_column_layout5050",
      content: [
        {
          position: "left",
          columns: ["54945muihGHk953tD21f1"],
        },
        {
          position: "right",
          columns: ["J9oj43gh3g534y45654h"],
        },
      ],
      style: {
        background: "#111",
        width: "100%",
        paddingTop: 10,
        paddingBottom: 10,
        paddingSelect: "select",
        wrap: "nowrap",
      },
    },
  ],
  columnData: [
    {
      _id: "0gEL5UTywUKrxbjf6HDHy",
      type: "column",
      fields: ["jAUD19BVwjGC5WSWDIO8O"],
      style: {
        width: "100%",
        background: "none",
      },
    },
    {
      _id: "54945muihGHk953tD21f1",
      type: "column",
      fields: ["G89234G8h34gg535g31", "h03FG93HG064u46j3325"],
      style: {
        width: "50%",
        background: "none",
      },
    },
    {
      _id: "J9oj43gh3g534y45654h",
      type: "column",
      fields: ["hjo93jG98k453g654h56h"],
      style: {
        width: "50%",
        background: "none",
      },
    },
    {
      _id: "1sEvvov8Oqktyp6-CeJNt",
      type: "column",
      fields: [
        "O0k54gj80565954gREhg54",
        "ydG7ASZvd0Oa6BrwYo8hL",
        "1T6IO7Hmnx-rjpV22iekq",
        "hntoim56FerbF34hg89",
      ],
      style: {
        width: "60%",
        background: "none",
        padding: "28px",
      },
    },
    {
      _id: "7vxqu0BKnkDJJxNU8iBUm",
      type: "column",
      fields: ["Ov81qtvSOtv5ITYRhqFDF"],
      style: {
        width: "100%",
        background: "none",
      },
    },
    {
      _id: "EvyPzsDPVb-3Jx3F9vqBJ",
      type: "column",
      fields: [
        "lVmlUAhNlFHC08a9g6wbo",
        "ibve1hOGwWhZSLyBtakWU",
        "bki4htrgRGe89jk53g54",
      ],
      style: {
        width: "33%",
        background: "none",
      },
    },
    {
      _id: "H9k4F9kt4Kb4hg3f3f1m",
      type: "column",
      fields: [
        "bl049FG9k4FDl0954hgg1",
        "Hp91i771Tmk-g9j84qYBU",
        "Vk934gG9k534gr09efrg",
      ],
      style: {
        width: "33%",
        background: "none",
      },
    },

    {
      _id: "mg954G9k534G9k534rth",
      type: "column",
      fields: ["F0kgbH45rthrthr4541"],
      style: {
        width: "100%",
        background: "none",
      },
    },

    {
      _id: "PSiKuYCIIjyUiVM5nMLjR",
      type: "column",
      fields: [
        "pDmiLz7ATant93rvnqSZX",
        "4OvKpkoWGjNZCMy54MQqH",
        "jkg8j54kiD345gSDh44y",
      ],
      style: {
        width: "33%",
        background: "none",
      },
    },
    {
      _id: "fydpEG38vjxUbtVjSxJwe",
      type: "column",
      fields: ["21ozPTyU49OX8rWE3R4Xd"],
      style: {
        width: "50%",
        background: "none",
      },
    },
    {
      _id: "ethn673rtb5366uk099",
      type: "column",
      fields: ["bqr0oqm0qimnjqb4b4"],
      style: {
        width: "100%",
        background: "#ffffff",
      },
    },
    {
      _id: "mydpE348vjxUbtVjSxJwe",
      type: "column",
      fields: ["70ozPTyU49OX8rWE3R4Xg"],
      style: {
        width: "50%",
        background: "none",
      },
    },
    {
      _id: "mmA1e65RfIIAa3IVubb7U",
      type: "column",
      fields: ["Ifiya4gZRAc7vZmWWG4z5"],
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
      },
    },
    {
      _id: "Gow8FD893uhh567hgv45",
      type: "column",
      fields: ["H5nj09435G£g3553h475F"],
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
      },
    },
    {
      _id: "abw4b5yh7924924650by9",
      type: "column",
      fields: ["8091g534uhng104hu9n"],
      style: {
        width: "25%",
        background: "none",
        textAlign: "center",
        padding: "10px",
      },
    },

    {
      _id: "sfdgFG943g£90k354gefb",
      type: "column",
      fields: ["pL3imhIq46mm0ihqg3gG"],
      style: {
        width: "25%",
        background: "none",
        textAlign: "center",
        padding: "10px",
      },
    },
    {
      _id: "Jokje0jVG£093jg345y3",
      type: "column",
      fields: ["Kkim3GF9ik3G9k354vfwe4"],
      style: {
        width: "25%",
        background: "none",
        textAlign: "center",
        padding: "10px",
      },
    },
    {
      _id: "aWetgr9k4htehtrg9k54h",
      type: "column",
      fields: ["fd10893G89j35G354g31"],
      style: {
        width: "25%",
        background: "none",
        textAlign: "center",
        padding: "10px",
      },
    },
    {
      _id: "rdTS-deY4VY8ANjWIxL8z",
      type: "column",
      fields: [
        "sqamlv2do7gOIHgg-3qOI",
        "oDzfyc60vInktmgnkQnEm",
        "htrlko5gk9G4ht0ij54hg",
      ],
      style: {
        background: "none",
      },
    },
    {
      _id: "uLHhlU_unzF58GxUi6nJF",
      type: "column",
      fields: ["bso1JAuD8RSkNstsoi066"],
      style: {
        width: "40%",
        background: "none",
      },
    },
    {
      _id: "ergt0kG54g809J54ghrt",
      type: "column",
      fields: ["hk94G93F9jh5h24312", "H9k3F93B04965h4fdg554"],
      style: {
        width: "33%",
        background: "none",
      },
    },
    {
      _id: "ggkmgK096VB89hj34g1",
      type: "column",
      fields: ["Ji938F8h25hg4gg6t31", "J9j34GVRgb9i3gewrj54e"],
      style: {
        width: "33%",
        background: "none",
      },
    },
    {
      _id: "gb45o9jh35IBenbuoiyt",
      type: "column",
      fields: ["FG9m534rgegbi9k4gtr", "R0keG93jg32Ddgggsd1"],
      style: {
        width: "33%",
        background: "none",
      },
    },
  ],
  fieldDefinitions: [
    {
      _id: "1T6IO7Hmnx-rjpV22iekq",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        marginTop: "20px",
        fontSize: "15px",
      },
    },
    {
      _id: "hntoim56FerbF34hg89",
      type: "button",
      style: {
        width: "100%",
        maxWidth: "150px",
        background: "#33507c",
        marginTop: "16px",
        fontSize: "13px",
        padding: "8px",
        borderRadius: "8px",
        color: "#fff",
        textAlign: "center",
        align: "left",
        position: "left",
      },
    },
    {
      _id: "21ozPTyU49OX8rWE3R4Xd",
      type: "image",
      style: {
        width: "60%",
        mobileWidth: "70%",
        maxWidth: "150px",
        align: "left",
        background: "none",
        position: "left",
      },
    },
    {
      _id: "bqr0oqm0qimnjqb4b4",
      type: "menu",
      style: {
        width: "100%",
        background: "#222222",
        color: "#ffffff",
        padding: "10px",
      },
    },
    {
      _id: "70ozPTyU49OX8rWE3R4Xg",
      type: "social",
      style: {
        width: "100%",
        background: "none",
        textAlign: "right",
        position: "right",
        socialColor: "original",
        display: "flex",
        justifyContent: "right",
        alignItems: "center",
        marginTop: "10px",
      },
    },
    {
      _id: "4OvKpkoWGjNZCMy54MQqH",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        fontSize: "16px",
        marginTop: "20px",
        marginBottom: "0px",
      },
    },
    {
      _id: "jkg8j54kiD345gSDh44y",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        fontSize: "13px",
        marginTop: "4px",
        marginBottom: "25px",
      },
    },
    {
      _id: "Hp91i771Tmk-g9j84qYBU",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        fontSize: "16px",
        marginTop: "20px",
        marginBottom: "0px",
      },
    },
    {
      _id: "Vk934gG9k534gr09efrg",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        fontSize: "13px",
        marginTop: "4px",
        marginBottom: "25px",
      },
    },

    {
      _id: "Ifiya4gZRAc7vZmWWG4z5",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        fontSize: "20px",
      },
    },
    {
      _id: "8091g534uhng104hu9n",
      type: "image",
      style: {
        width: "100%",
        background: "none",
      },
    },
    {
      _id: "pL3imhIq46mm0ihqg3gG",
      type: "image",
      style: {
        width: "100%",
        background: "none",
      },
    },
    {
      _id: "Kkim3GF9ik3G9k354vfwe4",
      type: "image",
      style: {
        width: "100%",
        background: "none",
      },
    },
    {
      _id: "fd10893G89j35G354g31",
      type: "image",
      style: {
        width: "100%",
        background: "none",
      },
    },
    {
      _id: "Ov81qtvSOtv5ITYRhqFDF",
      type: "image",
      text: {
        value:
          "<b><i>Lorem ipsum</i></b><br />dolor sit amet consectetur<br />adipiscing elit",
      },
      style: {
        width: "100%",
        maxWidth: "auto",
        align: "center",
        background: "none",
        text: {
          color: "#ffffff",
          fontSize: "30px",
          mobileFontSize: "20px",
          paddingSelect: "select",
          paddingTop: "130px",
          paddingLeft: "70px",
          mobilePaddingTop: "10px",
          mobilePaddingLeft: "10px",
        },
      },
    },
    {
      _id: "bso1JAuD8RSkNstsoi066",
      type: "image",
      style: {
        width: "100%",
        background: "none",
      },
    },
    {
      _id: "H9k3F93B04965h4fdg554",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        fontSize: "14px",
        marginTop: "20px",
        marginBottom: "20px",
      },
    },

    {
      _id: "hk94G93F9jh5h24312",
      type: "icon",
      style: {
        width: "100%",
        padding: "4px",
        background: "#33507c",
        textAlign: "center",
        fontSize: "14px",
        marginTop: "0px",
        marginBottom: "20px",
        boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.3)",
      },
    },

    {
      _id: "J9j34GVRgb9i3gewrj54e",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        fontSize: "14px",
        marginTop: "20px",
        marginBottom: "20px",
      },
    },
    {
      _id: "Ji938F8h25hg4gg6t31",
      type: "icon",
      style: {
        width: "100%",
        padding: "4px",
        background: "#33507c",
        textAlign: "center",
        fontSize: "14px",
        marginTop: "0px",
        marginBottom: "20px",
        boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.3)",
      },
    },
    {
      _id: "R0keG93jg32Ddgggsd1",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        fontSize: "14px",
        marginTop: "20px",
        marginBottom: "20px",
      },
    },
    {
      _id: "FG9m534rgegbi9k4gtr",
      type: "icon",
      style: {
        width: "100%",
        padding: "4px",
        background: "#33507c",
        textAlign: "center",
        fontSize: "14px",
        marginTop: "0px",
        marginBottom: "20px",
        boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.3)",
      },
    },
    {
      _id: "ibve1hOGwWhZSLyBtakWU",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        fontSize: "16px",
        marginTop: "20px",
        marginBottom: "0px",
      },
    },
    {
      _id: "bki4htrgRGe89jk53g54",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        fontSize: "13px",
        marginTop: "4px",
        marginBottom: "25px",
      },
    },
    {
      _id: "jAUD19BVwjGC5WSWDIO8O",
      type: "image",
      text: {
        value:
          "Lorem ipsum<br />dolor sit amet consectetur<br />adipiscing elit",
      },
      style: {
        width: "100%",
        maxWidth: "auto",
        align: "center",
        background: "none",
        text: {
          color: "#ffffff",
          fontSize: "26px",
          mobileFontSize: "14px",
          align: "center",
          textAlign: "center",
          paddingSelect: "select",
          width: "100%",
          paddingTop: "90px",
          mobilePaddingTop: "10px",
        },
      },
    },
    {
      _id: "h03FG93HG064u46j3325",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        color: "#ffffff",
        paddingSelect: "select",
        paddingLeft: "20px",
        paddingTop: "20px",
        paddingBottom: "20px",
        fontSize: "13px",
      },
    },
    {
      _id: "G89234G8h34gg535g31",
      type: "text",
      style: {
        width: "60%",
        mobileWidth: "70%",
        maxWidth: "120px",
        align: "left",
        background: "none",
        position: "left",
        paddingLeft: "20px",
        paddingSelect: "select",
        paddingTop: "20px",
        paddingBottom: "0px",
      },
    },
    {
      _id: "hjo93jG98k453g654h56h",
      type: "social",
      style: {
        width: "100%",
        background: "none",
        textAlign: "right",
        position: "right",
        socialColor: "white",
        display: "flex",
        justifyContent: "right",
        alignItems: "center",
        marginTop: "10px",
      },
    },
    {
      _id: "lVmlUAhNlFHC08a9g6wbo",
      type: "image",
      style: {
        width: "94%",
        mobileWidth: "90%",
        align: "center",
        background: "none",
        position: "center",
        borderRadius: "8px",
        borderType: "solid",
        borderColor: "#ddd",
        borderSize: "3px",
        borderSelect: "all",
        boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.3)",
      },
    },
    {
      _id: "bl049FG9k4FDl0954hgg1",
      type: "image",
      style: {
        width: "94%",
        mobileWidth: "90%",
        align: "center",
        background: "none",
        position: "center",
        borderRadius: "8px",
        borderType: "solid",
        borderColor: "#ddd",
        borderSize: "3px",
        borderSelect: "all",
        boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.3)",
      },
    },
    {
      _id: "F0kgbH45rthrthr4541",
      type: "divider",
      style: {
        width: "98%",
        background: "none",
        textAlign: "center",
        marginTop: "0px",
        marginBottom: "0px",
        borderSelect: "select",
        borderTop: "1px",
        borderColor: "#ddd",
        borderType: "dashed",
      },
    },

    {
      _id: "H5nj09435G£g3553h475F",
      type: "divider",
      style: {
        width: "98%",
        background: "none",
        textAlign: "center",
        marginTop: "0px",
        marginBottom: "0px",
        borderSelect: "select",
        borderTop: "1px",
        borderColor: "#ddd",
        borderType: "dashed",
      },
    },

    {
      _id: "oDzfyc60vInktmgnkQnEm",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        marginTop: "10px",
        fontSize: "17px",
      },
    },

    {
      _id: "htrlko5gk9G4ht0ij54hg",
      type: "button",
      style: {
        width: "100%",
        maxWidth: "150px",
        background: "#33507c",
        marginTop: "16px",
        fontSize: "13px",
        padding: "8px",
        borderRadius: "8px",
        color: "#fff",
        textAlign: "center",
        align: "center",
        position: "center",
      },
    },
    {
      _id: "pDmiLz7ATant93rvnqSZX",
      type: "image",
      style: {
        width: "94%",
        mobileWidth: "90%",
        align: "center",
        background: "none",
        position: "center",
        borderRadius: "8px",
        borderType: "solid",
        borderColor: "#ddd",
        borderSize: "3px",
        borderSelect: "all",
        boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.3)",
      },
    },

    {
      _id: "sqamlv2do7gOIHgg-3qOI",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        textAlign: "center",
        marginTop: "40px",
        fontSize: "26px",
      },
    },
    {
      _id: "ydG7ASZvd0Oa6BrwYo8hL",
      type: "text",
      style: {
        width: "100%",
        background: "none",
        fontSize: "22px",
      },
    },
    {
      _id: "O0k54gj80565954gREhg54",
      type: "image",
      style: {
        width: "100%",
        background: "none",
        marginBottom: "22px",
      },
    },
  ],
  fieldData: [
    {
      _id: "ymsMTaKM12NCVJp0Fb3Fj",
      field_ref: "pDmiLz7ATant93rvnqSZX",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "001.jpg",
    },
    {
      _id: "vRkGehkg9F-9PCyjEUhgv",
      field_ref: "4OvKpkoWGjNZCMy54MQqH",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value: "<b>Lorem ipsum dolor</b>",
    },
    {
      _id: "DF89k4G9j335h9PCyjEUhgv",
      field_ref: "70ozPTyU49OX8rWE3R4Xg",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "social",
      value: "",
    },
    {
      _id: "43tmtrbVER9ke4trgVTRBE",
      field_ref: "jkg8j54kiD345gSDh44y",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value:
        "Consequat adipiscing lorem sit ut eiusmod consequat duis incididunt minim sed fugiat consectetur enim lorem dolor quis sit tempor esse.",
    },
    {
      _id: "quSioVhtoBSXELGXOgFcS",
      field_ref: "ibve1hOGwWhZSLyBtakWU",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value: "<b>Lorem ipsum dolor</b>",
    },
    {
      _id: "h50imh609k64h46h456h",
      field_ref: "bki4htrgRGe89jk53g54",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value:
        "Consequat adipiscing lorem sit ut eiusmod consequat duis incididunt minim sed fugiat consectetur enim lorem dolor quis sit tempor esse.",
    },
    {
      _id: "SqatDTeTCzoIYjprGadbZ",
      field_ref: "lVmlUAhNlFHC08a9g6wbo",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "003.jpg",
    },
    {
      _id: "4hg56TeTCzoIYjp4h5Z",
      field_ref: "bl049FG9k4FDl0954hgg1",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "004.jpg",
    },
    {
      _id: "bl34FD9j4htghghg42",
      field_ref: "F0kgbH45rthrthr4541",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "divider",
      value: "",
    },
    {
      _id: "hb93VF834g435h56j",
      field_ref: "H5nj09435G£g3553h475F",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "divider",
      value: "",
    },
    {
      _id: "1J8Bd6kqDHlRPVLQHkhll",
      field_ref: "Hp91i771Tmk-g9j84qYBU",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value: "<b>Lorem ipsum dolor</b>",
    },
    {
      _id: "48gGk93428Fj854385g5hg",
      field_ref: "Vk934gG9k534gr09efrg",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value:
        "Consequat adipiscing lorem sit ut eiusmod consequat duis incididunt minim sed fugiat consectetur enim lorem dolor quis sit tempor esse",
    },
    {
      _id: "lL5VO03O13rYOXmMVXtOH",
      field_ref: "bso1JAuD8RSkNstsoi066",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "005.jpg",
    },
    {
      _id: "vg3n2g4n9u0g34w5ytrhw",
      field_ref: "H9k3F93B04965h4fdg554",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value:
        "<b>Lorem ipsum dolor</b><br />Sit lorem eiusmod<br />ipsum consequat voluptate",
    },

    {
      _id: "HBlk9456kh4h456h1",
      field_ref: "hk94G93F9jh5h24312",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "icon",
      value: "fas fa-city",
    },

    {
      _id: "GF8gj4hDvbjm309k4hn",
      field_ref: "J9j34GVRgb9i3gewrj54e",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value:
        "<b>Lorem ipsum dolor</b><br />Sit lorem eiusmod<br />ipsum consequat voluptate",
    },
    {
      _id: "bv03V934j45h4h411",
      field_ref: "Ji938F8h25hg4gg6t31",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "icon",
      value: "fas fa-user-alt",
    },
    {
      _id: "J04vb35gKJ4jn3487h32",
      field_ref: "R0keG93jg32Ddgggsd1",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value:
        "<b>Lorem ipsum dolor</b><br />Sit lorem eiusmod<br />ipsum consequat voluptate",
    },
    {
      _id: "h6hik9h656jh56MUUK56",
      field_ref: "FG9m534rgegbi9k4gtr",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "icon",
      value: "fas fa-map-marker-alt",
    },
    {
      _id: "NvIXKOtr87cnF15a9Z2fL",
      field_ref: "oDzfyc60vInktmgnkQnEm",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value:
        "Eiusmod ut labore quis et exercitation labore quis incididunt amet voluptate exercitation nostrud<br />Nostrud sit eiusmod fugiat aliqua minim laboris dolor fugiat et et lorem cillum",
    },
    {
      _id: "HG53g8jg53etrhqrthF",
      field_ref: "htrlko5gk9G4ht0ij54hg",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "button",
      value: "Click here",
    },

    {
      _id: "QCjOkkNsjChM9vUHEeQPs",
      field_ref: "sqamlv2do7gOIHgg-3qOI",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value: "<b>Lorem ipsum dolor</b>",
    },
    {
      _id: "g3hIx9562nP8fW1B6oQuf",
      field_ref: "Ifiya4gZRAc7vZmWWG4z5",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value: "<b>Lorem ipsum dolor</b>",
    },
    {
      _id: "nw56h03gvo64hq345h14",
      field_ref: "8091g534uhng104hu9n",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "008.jpg",
    },
    {
      _id: "G09k4F9jk534g45g3411",
      field_ref: "pL3imhIq46mm0ihqg3gG",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "009.jpg",
    },
    {
      _id: "450k35u8njGg423H543h534",
      field_ref: "Kkim3GF9ik3G9k354vfwe4",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "010.jpg",
    },
    {
      _id: "Sf09k34fNM095348uj34g",
      field_ref: "fd10893G89j35G354g31",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "011.jpg",
    },
    {
      _id: "t0N0S7a4GMm3Wfl6aydzr",
      field_ref: "21ozPTyU49OX8rWE3R4Xd",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "logo.png",
    },
    {
      _id: "39m25ug6bn56g5b36gg4m",
      field_ref: "bqr0oqm0qimnjqb4b4",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "menu",
      value: "",
    },

    {
      _id: "_VaTVCgOvni_4z3b3ztDS",
      field_ref: "Ov81qtvSOtv5ITYRhqFDF",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "002.jpg",
    },
    {
      _id: "hXbjPmCwc0rTC-_ZZSdUn",
      field_ref: "ydG7ASZvd0Oa6BrwYo8hL",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value: "<b>Lorem ipsum dolor</b>",
    },
    {
      _id: "p54ytlM09kGE5Rl9ehtrg",
      field_ref: "O0k54gj80565954gREhg54",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "006.jpg",
    },
    {
      _id: "t5HzwPrG0AU5T_yaxYDBy",
      field_ref: "jAUD19BVwjGC5WSWDIO8O",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "007.jpg",
    },
    {
      _id: "vb93B94hn46h6311",
      field_ref: "h03FG93HG064u46j3325",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value:
        "Amet exercitation sed<br />laboris magna veniam<br />commodo ipsum<br />consectetur consequat<br />consectetur laboris<br />",
    },

    {
      _id: "fkgb85Gi9jhj56hj56",
      field_ref: "G89234G8h34gg535g31",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "image",
      value: "logo_white.png",
    },
    {
      _id: "f8h38F9j345G5340ikg",
      field_ref: "hjo93jG98k453g654h56h",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "social",
      value: "",
    },
    {
      _id: "jVkudagyVe9Xhktz_B59T",
      field_ref: "1T6IO7Hmnx-rjpV22iekq",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "text",
      value:
        "Magna quis duis fugiat fugiat tempor esse lorem voluptate aliquip labore esse sed<br />Duis elit ut et aliqua laboris veniam dolor minim consectetur nostrud tempor laboris<br />Nostrud esse magna adipiscing quis tempor incididunt et amet",
    },
    {
      _id: "hol54hg9g54h0k4569hgj",
      field_ref: "hntoim56FerbF34hg89",
      page: "4dTQcIGijLUuqB-j3H_me",
      type: "button",
      value: "Click here",
    },
  ],
};

export default data;
